/* eslint-disable camelcase */
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

/* Log environment */
let env = process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : process.env.NODE_ENV;
console.log('ENVIRONMENT: ', env);

/* Connect to firebase project (same for test & production, no demo) */
const firebaseConfig = {
	apiKey: 'AIzaSyD8CiJ8HnNX4_IjxbecQxYhZZ4_ccKrVWU',
	authDomain: 'cgl-elevspilkort-n-test.firebaseapp.com',
	projectId: 'cgl-elevspilkort-n-test',
	storageBucket: 'cgl-elevspilkort-n-test.firebasestorage.app',
	messagingSenderId: '943090617496',
	appId: '1:943090617496:web:9a49ad79773ae0c8ec14ed'
};


/* Initialize firebase */
firebase.initializeApp(firebaseConfig);

export default firebase.firestore;